import { css } from '@emotion/react'
import styled from '@emotion/styled'

const checkboxWrapperStyles = ({ theme }) => css`
  label: checkbox__wrapper;

  display: block;
  padding-bottom: ${theme.spacings.byte};

  & > div label {
    padding-left: 0px;
    padding-right: 26px;

    & svg,
    :before {
      left: auto;
      right: 0;
    }
  }
`

const rightSpacingCheckboxWrapperStyles = ({ rightSpacing }) =>
  rightSpacing &&
  css`
    label: checkbox__wrapper--max-width;

    max-width: calc(100% - ${rightSpacing || 0}px);
  `

export const CheckboxWrapper = styled('a')(
  checkboxWrapperStyles,
  rightSpacingCheckboxWrapperStyles
)
